"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var util_1 = require("@gooddata/util");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var constants_1 = require("../constants");
var AttributeFilterButtonDropdownButton = function (props) {
    var isMobile = props.isMobile, isOpen = props.isOpen, title = props.title, subtitleItemCount = props.subtitleItemCount, subtitleText = props.subtitleText, isFiltering = props.isFiltering, isLoaded = props.isLoaded;
    var subtitleSelectedItemsRef = react_1.useRef(null);
    var _a = react_1.useState(false), displayItemCount = _a[0], setDisplayItemCount = _a[1];
    var _b = react_1.useState(""), subtitle = _b[0], setSubtitle = _b[1];
    react_1.useEffect(function () {
        if (!isEmpty_1.default(subtitleText) && subtitleText !== subtitle) {
            setSubtitle(subtitleText);
        }
    }, [subtitleText]);
    react_1.useEffect(function () {
        var element = subtitleSelectedItemsRef.current;
        if (!element) {
            return;
        }
        var roundedWidth = Math.ceil(element.getBoundingClientRect().width);
        var displayItemCount = roundedWidth < element.scrollWidth;
        setDisplayItemCount(displayItemCount);
    }, [subtitle]);
    return (react_1.default.createElement("div", { className: classnames_1.default("attribute-filter-button", "s-attribute-filter", "s-" + util_1.stringUtils.simplifyText(title), {
            "is-active": isOpen,
            "gd-attribute-filter-button-mobile": isMobile,
            "gd-attribute-filter-button-is-filtering": isFiltering,
            "is-loaded": isLoaded,
        }) },
        react_1.default.createElement("div", { className: "button-content" },
            react_1.default.createElement("div", { className: "button-title" },
                react_1.default.createElement(sdk_ui_kit_1.ShortenedText, { tooltipAlignPoints: constants_1.ATTRIBUTE_FILTER_BITTON_TOOLTIP_ALIGN_POINT, className: "s-attribute-filter-button-title" }, title)),
            react_1.default.createElement("div", { className: "button-subtitle" },
                react_1.default.createElement("span", { className: "button-selected-items s-attribute-filter-button-subtitle", ref: subtitleSelectedItemsRef }, subtitle),
                displayItemCount && (react_1.default.createElement("span", { className: "button-selected-items-count" }, "(" + subtitleItemCount + ")"))))));
};
exports.default = AttributeFilterButtonDropdownButton;
//# sourceMappingURL=AttributeFilterButtonDropdownButton.js.map